var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.carregando),expression:"carregando"}],attrs:{"id":"loader"}},[_c('ring-loader',{attrs:{"color":"#5bc0de"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }